"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var transerializable_1 = require("../trans/transerializable");
var DEFAULTED_KEY = "__@@__defaulted_props";
function isDefaultedEqual(o1, o2) {
    /*
     *  While the defaulted map is not enumerable, it is checked
     *  by lodash as lodash doesn't just operate over the Object.keys
     *  call but instead looks at
     */
    var filterDefaultMap = function (obj) {
        return lodash_1.reduce(Object.keys(obj), function (acc, key) {
            acc[key] = obj[key];
            return acc;
        }, {});
    };
    return lodash_1.isEqual(filterDefaultMap(o1), filterDefaultMap(o2));
}
exports.isDefaultedEqual = isDefaultedEqual;
function getDefaulted(obj) {
    return obj[DEFAULTED_KEY];
}
function isDefaultedObject(obj) {
    var defaulted = getDefaulted(obj);
    return defaulted && typeof defaulted === 'object';
}
function setDefault(obj, key) {
    if (!getDefaulted(obj)) {
        Object.defineProperty(obj, DEFAULTED_KEY, { value: {}, enumerable: false });
    }
    if (isDefaultedObject(obj)) {
        getDefaulted(obj)[key] = true;
    }
}
exports.setDefault = setDefault;
function unsetDefault(obj, key) {
    if (isDefaultedObject(obj)) {
        getDefaulted(obj)[key] = false;
    }
}
exports.unsetDefault = unsetDefault;
function isDefault(obj, key) {
    return isDefaultedObject(obj) && getDefaulted(obj)[key];
}
exports.isDefault = isDefault;
/**
 * Subtly different than "isDefault", this will return true
 * if the key is undecorated as defaultable.
 *
 * @param obj Object to check
 * @param key Key in object
 */
function isDefaultOrStompable(obj, key) {
    if (isDefaultedObject(obj) && getDefaulted(obj)[key] === undefined) {
        return true;
    }
    if (!isDefaultedObject(obj)) {
        return true;
    }
    return isDefault(obj, key);
}
exports.isDefaultOrStompable = isDefaultOrStompable;
function setAllDefaults(obj) {
    setDefaults(obj, Object.keys(obj));
}
exports.setAllDefaults = setAllDefaults;
function setDefaults(obj, keys) {
    [].concat(keys).forEach(function (key) { return setDefault(obj, key); });
}
exports.setDefaults = setDefaults;
function findKeyOrThis(obj) {
    return (obj[transerializable_1.ID_KEY]) ? obj[transerializable_1.ID_KEY] : obj;
}
function propertyMapper(prototype, key, mapper) {
    var values = new Map();
    Object.defineProperty(prototype, key, {
        set: function (firstValue) {
            Object.defineProperty(this, key, {
                get: function () {
                    return values.get(findKeyOrThis(this));
                },
                set: function (value) {
                    if (isDefault(this, key)) {
                        unsetDefault(this, key);
                    }
                    else {
                        setDefault(this, key);
                    }
                    values.set(findKeyOrThis(this), mapper(value));
                },
                enumerable: true
            });
            this[key] = firstValue;
        },
        enumerable: true,
        configurable: true
    });
}
exports.propertyMapper = propertyMapper;
function defaultProperty() {
    return function (target, key) {
        propertyMapper(target, key, function (value) { return value; });
    };
}
exports.defaultProperty = defaultProperty;
//# sourceMappingURL=defaults.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/defaults/defaults.js
 ** module id = 1054
 ** module chunks = 0
 **/